/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DoctorApplicationStatusEnum } from './DoctorApplicationStatusEnum';
import {
    DoctorApplicationStatusEnumFromJSON,
    DoctorApplicationStatusEnumFromJSONTyped,
    DoctorApplicationStatusEnumToJSON,
} from './DoctorApplicationStatusEnum';
import type { SexEnum } from './SexEnum';
import {
    SexEnumFromJSON,
    SexEnumFromJSONTyped,
    SexEnumToJSON,
} from './SexEnum';
import type { SpecialtiesEnum } from './SpecialtiesEnum';
import {
    SpecialtiesEnumFromJSON,
    SpecialtiesEnumFromJSONTyped,
    SpecialtiesEnumToJSON,
} from './SpecialtiesEnum';
import type { SubSpecialtiesEnum } from './SubSpecialtiesEnum';
import {
    SubSpecialtiesEnumFromJSON,
    SubSpecialtiesEnumFromJSONTyped,
    SubSpecialtiesEnumToJSON,
} from './SubSpecialtiesEnum';

/**
 * 
 * @export
 * @interface DoctorInfoOut
 */
export interface DoctorInfoOut {
    /**
     *
     * @type {string}
     * @memberof DoctorInfoOut
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof DoctorInfoOut
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorInfoOut
     */
    phoneNumber?: string;
    /**
     * 
     * @type {SpecialtiesEnum}
     * @memberof DoctorInfoOut
     */
    specialty?: SpecialtiesEnum;
    /**
     * 
     * @type {SubSpecialtiesEnum}
     * @memberof DoctorInfoOut
     */
    subSpecialty?: SubSpecialtiesEnum;
    /**
     * 
     * @type {SexEnum}
     * @memberof DoctorInfoOut
     */
    sex?: SexEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorInfoOut
     */
    nationalId?: string;
    /**
     * 
     * @type {DoctorApplicationStatusEnum}
     * @memberof DoctorInfoOut
     */
    status?: DoctorApplicationStatusEnum;
}

/**
 * Check if a given object implements the DoctorInfoOut interface.
 */
export function instanceOfDoctorInfoOut(value: object): boolean {
    return true;
}

export function DoctorInfoOutFromJSON(json: any): DoctorInfoOut {
    return DoctorInfoOutFromJSONTyped(json, false);
}

export function DoctorInfoOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorInfoOut {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'] == null ? undefined : json['id'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
        'specialty': json['specialty'] == null ? undefined : SpecialtiesEnumFromJSON(json['specialty']),
        'subSpecialty': json['sub_specialty'] == null ? undefined : SubSpecialtiesEnumFromJSON(json['sub_specialty']),
        'sex': json['sex'] == null ? undefined : SexEnumFromJSON(json['sex']),
        'status': json['status'] == null ? undefined : DoctorApplicationStatusEnumFromJSON(json['status']),
    };
}

export function DoctorInfoOutToJSON(value?: DoctorInfoOut | null): any {
    if (value == null) {
        return value;
    }
    return {

        'id': value['id'],
        'full_name': value['fullName'],
        'phone_number': value['phoneNumber'],
        'specialty': SpecialtiesEnumToJSON(value['specialty']),
        'sub_specialty': SubSpecialtiesEnumToJSON(value['subSpecialty']),
        'sex': SexEnumToJSON(value['sex']),
        'status': DoctorApplicationStatusEnumToJSON(value['status']),
    };
}

